import { Paper, Stack, Typography } from "@mui/material";

const PricingPage = () => (
  <Stack spacing={3}>
    <Typography variant="h3">Pricing</Typography>
    <Paper
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: 4,
        border: "1px solid rgba(13, 27, 42, 0.06)",
        background: "rgba(255, 255, 255, 0.95)",
      }}
    >
      <Typography color="text.secondary">
        Every facility is different. Share your project scope and we will build
        a tailored package for monitoring, analytics, and ongoing support.
      </Typography>
    </Paper>
  </Stack>
);

export default PricingPage;
